// src/pages/dashboard/Dashboard.js
import React, { useEffect, useState, useRef } from "react";
import useAuth from "../../hooks/useAuth";
import { useNavigate, useLocation } from "react-router-dom";
import ProjectForm from "../../components/projects/ProjectForm";
import "./Dashboard.css";
import MaterialUpload from "../Materials/MaterialUpload";
import {
  getLearnerPastAssestment,
  downloadLearnerAssessmentPDF,
} from "../../api/learner/learnerApi";
import { getProjects } from "../../api/project/projectApi";
import { FaEye, FaSquarePlus } from "react-icons/fa6";
import { IoStatsChart } from "react-icons/io5";
import { FaFileDownload } from "react-icons/fa";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import CertificateBg from "../../assets/images/bg.png";
import SBILogo from "../../assets/images/SBI.png";
import logo from "../../assets/images/myassessment.ai_logo.png";
import PostLoginPopup from "../../components/common/PostLoginPopUp";
pdfMake.vfs = pdfFonts.vfs;
// import {noDataGif} from "../../assets/images/no-data.gif"

const Dashboard = () => {
  const { user, logout } = useAuth();
  const currentDate = new Date().toLocaleDateString();
  const [showProjectForm, setShowProjectForm] = useState(false);
  const [showAssessmentForm, setShowAssessmentForm] = useState(false);
  const [viewAssestment, setViewAssestment] = useState(true);
  const [userEmail, setUserEmail] = useState("");
  const [pastAssestmentData, setPastAssestmentData] = useState([]);
  const [projects, setProjects] = useState([]);
  const user_id = localStorage.getItem("user_id");
  const projectModalRef = useRef(null);
  const [logo64Image, setLogo64Image] = useState(null);
  const [base64Image, setBase64Image] = useState(null);
  const [SBI64Image, setSBI64Image] = useState(null);
  const [showPostLoginPopup, setShowPostLoginPopup] = useState(false);
  const location = useLocation();

  const handleDownloadPDF = (assessmentId) => {
    //console.log(assessmentId);
    downloadLearnerAssessmentPDF(assessmentId);
  };

  useEffect(() => {
    const convertImageToBase64 = async () => {
      try {
        const response = await fetch(CertificateBg);
        const blob = await response.blob();
        const reader = new FileReader();

        reader.onloadend = () => {
          setBase64Image(reader.result);
        };

        reader.readAsDataURL(blob);
      } catch (error) {
        console.error("Error converting image to Base64:", error);
      }
    };

    convertImageToBase64();
  }, []);

  useEffect(() => {
    if (location.state && location.state.showPopup) {
      setShowPostLoginPopup(true);
    }
  }, [location.state]);

  useEffect(() => {
    const convertImageToBase64Logo = async () => {
      try {
        const response = await fetch(logo);
        const blob = await response.blob();
        const reader = new FileReader();

        reader.onloadend = () => {
          setLogo64Image(reader.result);
        };

        reader.readAsDataURL(blob);
      } catch (error) {
        console.error("Error converting image to Base64:", error);
      }
    };
    convertImageToBase64Logo();
  }, []);

  useEffect(() => {
    const convertImageToBase64LogoSBI = async () => {
      try {
        const response = await fetch(SBILogo);
        const blob = await response.blob();
        const reader = new FileReader();

        reader.onloadend = () => {
          setSBI64Image(reader.result);
        };

        reader.readAsDataURL(blob);
      } catch (error) {
        console.error("Error converting image to Base64:", error);
      }
    };
    convertImageToBase64LogoSBI();
  }, []);

  const handleDownloadCertificate = (assessment) => {
    const maxScore = calculateMarks(assessment.marks_per_section);
    const userScore = roundToDecimal(assessment.total_score || 0);
    const currentDate = new Date().toLocaleDateString();
    if (assessment.question_code != "C-I6J84E-PO") {
      const docDefinition = {
        pageSize: "A4",
        pageOrientation: "landscape",
        pageMargins: [40, 60, 40, 60],
        background: [
          {
            image: base64Image,
            fit: [841, 595],
            absolutePosition: { x: 0, y: 0 },
          },
        ],

        content: [
          {
            text: "Certificate of Achievement",
            style: "header",
          },
          {
            text: "This is to certify that",
            style: "subheader",
          },
          {
            text: `${user?.fullName || "Unnamed User"}`,
            style: "awardeeName",
          },
          {
            text: `has successfully completed the assessment '${
              assessment.project_name
            }' (${
              assessment.question_code || "N/A"
            }) with a score of ${userScore} out of ${maxScore}.`,
            style: "bodyText",
            margin: [0, 0, 0, 8],
          },
          {
            text: `Date Awarded: ${currentDate}`,
            style: "bodyText",
          },
          {
            text: "Congratulations on your accomplishment!",
            italics: true,
            alignment: "center",
            margin: [0, 30, 0, 0],
          },
          {
            image: logo64Image,
            width: 180,
            height: 80,
            alignment: "center",
            margin: [0, 20, 0, 0],
          },
        ],

        styles: {
          header: {
            fontSize: 28,
            bold: true,
            alignment: "center",
            margin: [0, 30, 0, 10],
            color: "#4a4a4a",
          },
          subheader: {
            fontSize: 16,
            alignment: "center",
            margin: [0, 10, 0, 2],
          },
          awardeeName: {
            fontSize: 22,
            bold: true,
            color: "#d9ab38",
            alignment: "center",
            margin: [0, 4, 0, 15],
          },
          bodyText: {
            fontSize: 14,
            alignment: "center",
            margin: [40, 0, 40, 0],
          },
        },
      };
      pdfMake
        .createPdf(docDefinition)
        .download(`Certificate_${assessment._id}.pdf`);
    } else {
      const docDefinition = {
        pageSize: "A4",
        pageOrientation: "landscape",
        pageMargins: [40, 60, 40, 60],
        background: [
          {
            image: base64Image,
            fit: [841, 595],
            absolutePosition: { x: 0, y: 0 },
          },
        ],

        content: [
          {
            text: "Certificate of Achievement",
            style: "header",
          },
          {
            text: "This is to certify that",
            style: "subheader",
          },
          {
            text: `${user?.fullName || "Unnamed User"}`,
            style: "awardeeName",
          },
          {
            text: `has successfully completed the specialized training program conducted by '${assessment.project_name}' with a score of ${userScore} out of ${maxScore}.`,
            style: "bodyText",
            margin: [0, 0, 0, 8],
          },
          {
            text: `Date Awarded: ${currentDate}`,
            style: "bodyText",
          },
          {
            text: "Congratulations on your accomplishment!",
            italics: true,
            alignment: "center",
            margin: [0, 30, 0, 0],
          },
          {
            image: SBI64Image,
            width: 160,
            height: 40,
            alignment: "center",
            margin: [0, 20, 0, 0],
          },
        ],

        styles: {
          header: {
            fontSize: 28,
            bold: true,
            alignment: "center",
            margin: [0, 30, 0, 10],
            color: "#4a4a4a",
          },
          subheader: {
            fontSize: 16,
            alignment: "center",
            margin: [0, 10, 0, 2],
          },
          awardeeName: {
            fontSize: 22,
            bold: true,
            color: "#d9ab38",
            alignment: "center",
            margin: [0, 4, 0, 15],
          },
          bodyText: {
            fontSize: 14,
            alignment: "center",
            margin: [40, 0, 40, 0],
          },
        },
      };
      pdfMake
        .createPdf(docDefinition)
        .download(`Certificate_${assessment._id}.pdf`);
    }
  };

  useEffect(() => {
    if (showProjectForm && projectModalRef.current) {
      projectModalRef.current.focus();
    }
  }, [showProjectForm]);


  const navigate = useNavigate();

  const handlePass = () => {
    setShowPostLoginPopup(false);
    navigate('/dashboard', { replace: true });
  };

  const handleFail = () => {
    setShowPostLoginPopup(false);
    navigate('/profile');
  };

  const toggleProjectForm = () => {
    setShowProjectForm(!showProjectForm);
  };

  const toggleAssessmentForm = () => {
    setShowAssessmentForm(!showAssessmentForm);
  };

  const viewProjectsHandler = () => {
    navigate("/projects"); 
  };

  const viewConsumptionHandler = () => {
    navigate("/consumption_statistics");
  };

  const PastAssessmentHandler = (assestmentsId) => {
    navigate(`/pastAssessment/${assestmentsId}`);
  };

  useEffect(() => {
    const fetchPastAssesments = async () => {
      try {
        const response = await getLearnerPastAssestment(user?.email);
        const { data } = response;
        setPastAssestmentData(data?.data || []);
      } catch (error) {
        console.error("Error fetching past assessments:", error);
      }
    };

    if (user?.email) {
      setUserEmail(user.email);
      fetchPastAssesments();
    }
  }, [user?.email]);

  const calculateMarks = (marksPerSection) => {
    const total = Object.values(marksPerSection).reduce(
      (sum, marks) => sum + marks,
      0
    );
    return total;
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await getProjects(user_id);
        const projectData = response?.data?.projects || [];
        setProjects(projectData);
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };
    fetchProjects();
  }, []);

  const roundToDecimal = (num, decimals = 1) => {
    if (Number.isInteger(num)) return num; // No rounding needed for integers
    return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
  };
  const chartData = [
  {
    day: "Mon",
    created: 10,
    live: 5,
    nonLive: 5,
    participants: 8,
  },
  {
    day: "Tue",
    created: 6,
    live: 3,
    nonLive: 2,
    participants: 4,
  },
  {
    day: "Wed",
    created: 8,
    live: 4,
    nonLive: 3,
    participants: 6,
  },
];



return (
  <div className="min-h-screen flex flex-col bg-gradient-to-br from-gray-50 via-white to-gray-100">

    {showPostLoginPopup && (
      <PostLoginPopup onPass={handlePass} onFail={handleFail} />
    )}
   {showProjectForm && (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm p-4"
    onClick={toggleProjectForm}
  >
    <div
      className="w-full max-w-2xl"
      onClick={(e) => e.stopPropagation()}
    >
      <ProjectForm onClose={toggleProjectForm} />
    </div>
  </div>
)}
   <div className="flex-1 p-3 sm:p-4 md:p-6 space-y-6">    
     <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">    
       <div className="lg:col-span-9 col-span-1">  
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 bg-gradient-to-r from-indigo-50 to-purple-50 p-6 rounded-2xl shadow-inner relative z-0">

    {[
      { title: "Total no. of Assessments created", value: 10, label: "Assessment" },
      { title: "Total no. of Live Assessments", value: 5, label: "Assessment" },
      { title: "Total no. of Non-Live Assessments", value: 5, label: "Assessment" },
      { title: "Total Participant", value: 8, label: "Participants" },
      
    ].map((item, index) => (
      <div key={index} className="text-gray-700">
        <p className="text-xs uppercase tracking-wide text-gray-400 mb-1">
          {item.title}
        </p>
        <div className="flex items-center gap-2">
          <span className="text-3xl font-bold text-indigo-600">
            {item.value}
          </span>
          <span className="text-sm text-gray-500">{item.label}</span>
        </div>
      </div>
    ))}

  </div>


<div className="bg-white rounded-2xl shadow-xl p-6 -mt-6 relative z-10">
  <h3 className="text-lg font-semibold text-gray-700 mb-4">
    <span className="text-indigo-800 font-bold">Assessment</span> ACTIVITY
  </h3>

  {(() => {
    const totalAssessments = 10;
    const totalParticipants = 8;

    const maxValue = totalAssessments;

    return (
      <div className="h-48 sm:h-56 md:h-64 flex gap-4 md:gap-6">

        
        <div className="flex flex-col justify-between text-xs text-gray-500 pr-3">
          {[...Array(6)].map((_, i) => {
            const value = Math.round((maxValue / 5) * (5 - i));
            return <span key={i}>{value}</span>;
          })}
        </div>

        
       <div className="flex flex-col items-center justify-end h-full">
  <div className="relative w-10 sm:w-14 md:w-16 lg:w-20 h-full max-h-[220px] sm:max-h-[260px] md:max-h-[300px] bg-indigo-600 rounded-t-xl flex items-end justify-center overflow-hidden">
    <div
      style={{
        height: `${
          totalAssessments
            ? (totalParticipants / totalAssessments) * 100
            : 0
        }%`,
      }}
      className="w-full bg-indigo-300 absolute bottom-0 transition-all duration-500"
    ></div>

    
    <span className="absolute bottom-2 text-[10px] sm:text-xs text-white font-semibold">
      {totalParticipants}/{totalAssessments}
    </span>
  </div>


  <span className="mt-2 text-[11px] sm:text-xs md:text-sm text-gray-700 font-medium text-center">
    Participants: {totalParticipants}
  </span>

</div>
      </div>
    );
  })()}

</div>
</div>

       
<div className="lg:col-span-3 col-span-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">


  <div
    onClick={toggleProjectForm}
    className="cursor-pointer flex-1 p-5 rounded-3xl bg-gradient-to-l from-indigo-950 to-indigo-800 text-white shadow-xl backdrop-blur-lg border border-white/20 hover:scale-[1.03] hover:shadow-2xl transition-all duration-300 flex flex-col justify-between"
  >
    <div className="flex items-center gap-3">
      <div className="bg-white/20 p-3 rounded-full text-xl">
        <FaSquarePlus />
      </div>
      <span className="font-semibold text-base md:text-lg">Create Assessment</span>
    </div>

    <p className="text-sm text-white/90 mt-4">
      Start creating new assessments quickly and easily.
    </p>
  </div>


  <div
    onClick={viewProjectsHandler}
    className="cursor-pointer flex-1 p-5 rounded-3xl  bg-gradient-to-l from-indigo-950 to-indigo-800 text-white shadow-xl backdrop-blur-lg border border-white/20 hover:scale-[1.03] hover:shadow-2xl transition-all duration-300 flex flex-col justify-between"
  >
    <div className="flex items-center gap-3">
      <div className="bg-white/20 p-3 rounded-full text-xl">
        <FaEye />
      </div>
      <span className="font-semibold text-lg">View Assessments</span>
    </div>

    <p className="text-sm text-white/90 mt-4">
      Explore and manage all your created assessments.
    </p>
  </div>
  <div
    onClick={viewConsumptionHandler}
    className="cursor-pointer flex-1 p-5 rounded-3xl bg-gradient-to-l from-indigo-950 to-indigo-800 text-white shadow-xl backdrop-blur-lg border border-white/20 hover:scale-[1.03] hover:shadow-2xl transition-all duration-300 flex flex-col justify-between"
  >
    <div className="flex items-center gap-3">
      <div className="bg-white/20 p-3 rounded-full text-xl">
        <IoStatsChart />
      </div>
      <span className="font-semibold text-lg">Usage Statistics</span>
    </div>

    <p className="text-sm text-white/90 mt-4">
      Track usage, performance, and analytics insights.
    </p>
  </div>

</div>
      </div>

     
<div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl shadow-md p-4 md:p-6">
  <h3 className="text-lg font-semibold mb-4 text-indigo-800">
    Recent Assessments
  </h3>

  <div className="space-y-3 bg-white">
    {(pastAssestmentData || []).slice(0, 3).map((item, index) => (
      <div
        key={item._id}
        className="p-4 border hover:bg-gray-50 cursor-pointer flex justify-between items-center"
        onClick={() => PastAssessmentHandler(item._id)}
      >
       
        <div>
          <p className="font-semibold text-gray-800">
            {item.project_name || "Untitled Assessment"}
          </p>
          <p className="text-xs text-gray-500">
            Code: {item.question_code || "N/A"}
          </p>
        </div>

     
        <div className="text-right">
          <p className="text-sm font-medium text-indigo-600">
            {item.total_score ?? 0}
          </p>
          <p className="text-xs text-gray-400">
            Score
          </p>
        </div>
      </div>
    ))}
  </div>
</div>

    
      {!viewAssestment && pastAssestmentData.length > 0 ? (
        <div className="lg:w-10/12 w-full mx-auto">
         
        </div>
      ) : !viewAssestment ? (
        <div className="text-center py-10 text-gray-500">
          <img
            src="./no-data.gif"
            alt="No Results Found"
            className="w-40 mx-auto"
          />
        </div>
      ) : null}

    </div>
  </div>
);
};
export default Dashboard;
